/* eslint-disable */
import {useTranslation} from "react-i18next";
import PaymentLogos from "../../components/PaymentLogos";
import React from "react";
import {StripePrice} from "../SubscriptionDetail";

const PaymentInfoBlock = ({ selectedPrice, subRenewDescriptionShow, isPriceSingle, prices }: {
    selectedPrice?: StripePrice | null,
    subRenewDescriptionShow: boolean,
    isPriceSingle: boolean,
    prices: StripePrice[]
}) => {
    const { t } = useTranslation();
    if (!selectedPrice) {
        return (
            <div className="payment-info-block">
                {subRenewDescriptionShow && <div className="payment-info-text">
                    {t('subscription.defaultTrialMessage')}
                </div>}
                <PaymentLogos />
            </div>
        );
    }
    const interval = selectedPrice.recurring?.interval || 'month';
    const intervalCount = selectedPrice.recurring?.interval_count || 1;
    const priceNumber = selectedPrice.currency === 'usd' ||selectedPrice.currency === 'eur'  ?
        selectedPrice.unit_amount / 100 : selectedPrice.unit_amount;
    console.log('price number ', priceNumber)
    const formattedPrice = priceNumber.toLocaleString('en-US', {
        style: 'currency',
        currency: selectedPrice.currency.toUpperCase()
    });
    console.log('formatted price ', formattedPrice)

    // Format the interval text
    const getLocalizedInterval = (interval: string, count: number) => {
        const key = count > 1 ? `subscription.intervals.${interval}s` : `subscription.intervals.${interval}`;
        return t(key);
    };
    const intervalWithCount = `${intervalCount} ${getLocalizedInterval(interval, intervalCount)}`;

    // Get second price and interval for renewal message when isPriceSingle is true
    let secondPrice = null;
    let secondIntervalWithCount = '';
    let formattedSecondPrice = '';

    if (isPriceSingle && prices && prices.length > 1) {
        // Find the second price (not the currently selected one)
        secondPrice = prices.find(p => p.id !== selectedPrice.id);
        if (secondPrice) {
            const secondInterval = secondPrice.recurring?.interval || 'month';
            const secondIntervalCount = secondPrice.recurring?.interval_count || 1;
            const secondPriceNumber = secondPrice.currency === 'usd' || secondPrice.currency ==='eur' ?
                secondPrice.unit_amount / 100 : selectedPrice.unit_amount;
            formattedSecondPrice = secondPriceNumber.toLocaleString('en-US', {
                style: 'currency',
                currency: secondPrice.currency.toUpperCase()
            });
            secondIntervalWithCount = `${secondIntervalCount} ${getLocalizedInterval(secondInterval, secondIntervalCount)}`;
        }
    }



    return (
        <div className="payment-info-block">
            {subRenewDescriptionShow &&  <div className="payment-info-text">
                {isPriceSingle ? (
                    // Show renewalMessage with two prices and intervals
                    <>
                        {/*{funnelVersion === 1 &&*/}
                        {/*  <>*/}
                        {/*    {t('subscription.renewalMessage', {*/}
                        {/*      firstIntervalCount: intervalWithCount,*/}
                        {/*      formattedPrice: formattedPrice,*/}
                        {/*    })}*/}
                        {/*    <a href="/terms" target={'_blank'} style={{textDecoration: 'underline'}}>{t('subscription.termsLinkList')}.</a>*/}
                        {/*    {t('subscription.renewalMessageSecond', {*/}
                        {/*      firstIntervalCount: intervalWithCount,*/}
                        {/*      formattedSecondPrice: formattedSecondPrice,*/}
                        {/*      secondIntervalCount: secondIntervalWithCount,*/}
                        {/*    })} <a href="/support" target={'_blank'} style={{textDecoration: 'underline'}}>{t('subscription.termsLink')}</a>.*/}
                        {/*  </>*/}
                        {/*}*/}
                    </>
                ) : (
                    // Show renewalMessageList with single price and interval
                    <>
                        {t('subscription.renewalMessageList', {
                            intervalWithCount: intervalWithCount,
                            formattedPrice: formattedPrice,
                        })} <a href="/terms" target={'_blank'} style={{textDecoration: 'underline'}}>{t('subscription.termsLinkList')}</a>.
                    </>
                )}
            </div>
            }
            <PaymentLogos />
        </div>
    );
};

export default PaymentInfoBlock
